// TODO 需棄用
// 請改用 useTable

export const pageStartIndex = (curPage, limit) => {
  if (curPage === 1) return 0
  return (curPage * limit) - limit
}
